// extracted by mini-css-extract-plugin
export var autoExpand = "_2v-8";
export var container = "_2v-7";
export var containerWidth = "_2v-5";
export var disabled = "_2v-2";
export var error = "_2v-3";
export var fullWidth = "_2v-6";
export var inputWrapper = "_2v-0";
export var small = "_2v-1";
export var textarea = "_2v-4";